import styled from "@emotion/styled";

export const GridRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
`;

export const GridItemRoot = styled.div`
  width: 25%;
  padding: 0.5rem;
`;
